webpackJsonp([278782420861076],{

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Transition = _interopRequireDefault(__webpack_require__(103));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _transitions = __webpack_require__(105);
	
	var _utils = __webpack_require__(167);
	
	// @inheritedComponent Transition
	var styles = function styles(theme) {
	  return {
	    container: {
	      height: 0,
	      overflow: 'hidden',
	      transition: theme.transitions.create('height')
	    },
	    entered: {
	      height: 'auto'
	    },
	    wrapper: {
	      // Hack to get children with a negative margin to not falsify the height computation.
	      display: 'flex'
	    },
	    wrapperInner: {
	      width: '100%'
	    }
	  };
	};
	/**
	 * The Collapse transition is used by the
	 * [Vertical Stepper](/demos/steppers#vertical-stepper) StepContent component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	exports.styles = styles;
	
	var Collapse =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Collapse, _React$Component);
	
	  function Collapse() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Collapse);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Collapse.__proto__ || (0, _getPrototypeOf.default)(Collapse)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "wrapper", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "autoTransitionDuration", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "timer", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        node.style.height = _this.props.collapsedHeight;
	
	        if (_this.props.onEnter) {
	          _this.props.onEnter(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEntering", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var _this$props = _this.props,
	            timeout = _this$props.timeout,
	            theme = _this$props.theme;
	        var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	
	        var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'enter'
	        }),
	            transitionDuration = _getTransitionProps.duration;
	
	        if (timeout === 'auto') {
	          var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	          node.style.transitionDuration = "".concat(duration2, "ms");
	          _this.autoTransitionDuration = duration2;
	        } else {
	          node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	        }
	
	        node.style.height = "".concat(wrapperHeight, "px");
	
	        if (_this.props.onEntering) {
	          _this.props.onEntering(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEntered", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        node.style.height = 'auto';
	
	        if (_this.props.onEntered) {
	          _this.props.onEntered(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExit", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	        node.style.height = "".concat(wrapperHeight, "px");
	
	        if (_this.props.onExit) {
	          _this.props.onExit(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExiting", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var _this$props2 = _this.props,
	            timeout = _this$props2.timeout,
	            theme = _this$props2.theme;
	        var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	
	        var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'exit'
	        }),
	            transitionDuration = _getTransitionProps2.duration;
	
	        if (timeout === 'auto') {
	          var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	          node.style.transitionDuration = "".concat(duration2, "ms");
	          _this.autoTransitionDuration = duration2;
	        } else {
	          node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	        }
	
	        node.style.height = _this.props.collapsedHeight;
	
	        if (_this.props.onExiting) {
	          _this.props.onExiting(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "addEndListener", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(_, next) {
	        if (_this.props.timeout === 'auto') {
	          _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Collapse, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          collapsedHeight = _props.collapsedHeight,
	          Component = _props.component,
	          onEnter = _props.onEnter,
	          onEntered = _props.onEntered,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExiting = _props.onExiting,
	          style = _props.style,
	          theme = _props.theme,
	          timeout = _props.timeout,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "collapsedHeight", "component", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "theme", "timeout"]);
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onEntered: this.handleEntered,
	        onEntering: this.handleEntering,
	        onExit: this.handleExit,
	        onExiting: this.handleExiting,
	        addEndListener: this.addEndListener,
	        timeout: timeout === 'auto' ? null : timeout
	      }, other), function (state, childProps) {
	        return _react.default.createElement(Component, (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.entered, state === 'entered'), className),
	          style: (0, _objectSpread2.default)({}, style, {
	            minHeight: collapsedHeight
	          })
	        }, childProps), _react.default.createElement("div", {
	          className: classes.wrapper,
	          ref: function ref(node) {
	            _this2.wrapper = node;
	          }
	        }, _react.default.createElement("div", {
	          className: classes.wrapperInner
	        }, children)));
	      });
	    }
	  }]);
	  return Collapse;
	}(_react.default.Component);
	
	Collapse.propTypes =  false ? {
	  /**
	   * The content node to be collapsed.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The height of the container when collapsed.
	   */
	  collapsedHeight: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])])
	} : {};
	Collapse.defaultProps = {
	  collapsedHeight: '0px',
	  component: 'div',
	  timeout: _transitions.duration.standard
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  withTheme: true,
	  name: 'MuiCollapse'
	})(Collapse);
	
	exports.default = _default;

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	
	var _Collapse = _interopRequireDefault(__webpack_require__(429));

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(430));
	
	var _Paper = _interopRequireDefault(__webpack_require__(78));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _reactHelpers = __webpack_require__(168);
	
	// @inheritedComponent Paper
	// Workaround https://github.com/jsdom/jsdom/issues/2026
	var edgeFix = typeof window !== 'undefined' && /jsdom/.test(window.navigator.userAgent) ? {} : {
	  // Fix a rendering issue on Edge
	  '@supports (-ms-ime-align: auto)': {
	    borderBottomLeftRadius: 0,
	    borderBottomRightRadius: 0
	  }
	};
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    root: {
	      position: 'relative',
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        borderTopLeftRadius: 2,
	        borderTopRightRadius: 2,
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&:last-child': (0, _objectSpread2.default)({
	        borderBottomLeftRadius: 2,
	        borderBottomRightRadius: 2
	      }, edgeFix),
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      }
	    },
	    expanded: {
	      margin: "".concat(theme.spacing.unit * 2, "px 0"),
	      '&:first-child': {
	        marginTop: 0
	      },
	      '&:last-child': {
	        marginBottom: 0
	      },
	      '&:before': {
	        opacity: 0
	      }
	    },
	    disabled: {
	      backgroundColor: theme.palette.action.disabledBackground
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ExpansionPanel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ExpansionPanel, _React$Component);
	
	  function ExpansionPanel(props, context) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, ExpansionPanel);
	    _this = (0, _possibleConstructorReturn2.default)(this, (ExpansionPanel.__proto__ || (0, _getPrototypeOf.default)(ExpansionPanel)).call(this, props, context));
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {}
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "isControlled", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleChange", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;
	
	        if (!_this.isControlled) {
	          _this.setState({
	            expanded: !expanded
	          });
	        }
	
	        if (_this.props.onChange) {
	          _this.props.onChange(event, !expanded);
	        }
	      }
	    });
	    _this.isControlled = props.expanded != null;
	
	    if (!_this.isControlled) {
	      // not controlled, use internal state
	      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
	    }
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(ExpansionPanel, [{
	    key: "render",
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          CollapsePropsProp = _props.CollapseProps,
	          defaultExpanded = _props.defaultExpanded,
	          disabled = _props.disabled,
	          expandedProp = _props.expanded,
	          onChange = _props.onChange,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "CollapseProps", "defaultExpanded", "disabled", "expanded", "onChange"]);
	      var expanded = this.isControlled ? expandedProp : this.state.expanded;
	      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
	      var summary = null;
	
	      var children = _react.default.Children.map(childrenProp, function (child) {
	        if (!_react.default.isValidElement(child)) {
	          return null;
	        }
	
	        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
	          summary = _react.default.cloneElement(child, {
	            disabled: disabled,
	            expanded: expanded,
	            onChange: _this2.handleChange
	          });
	          return null;
	        }
	
	        return child;
	      });
	
	      var CollapseProps = !expanded ? {
	        'aria-hidden': 'true'
	      } : null;
	      return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	        className: className,
	        elevation: 1,
	        square: true
	      }, other), summary, _react.default.createElement(_Collapse.default, (0, _extends2.default)({
	        "in": expanded,
	        timeout: "auto"
	      }, CollapseProps, CollapsePropsProp), children));
	    }
	  }]);
	  return ExpansionPanel;
	}(_react.default.Component);
	
	ExpansionPanel.propTypes =  false ? {
	  /**
	   * The content of the expansion panel.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Properties applied to the `Collapse` element.
	   */
	  CollapseProps: _propTypes.default.object,
	
	  /**
	   * If `true`, expands the panel by default.
	   */
	  defaultExpanded: _propTypes.default.bool,
	
	  /**
	   * If `true`, the panel will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, expands the panel, otherwise collapse it.
	   * Setting this prop enables control over the panel.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {boolean} expanded The `expanded` state of the panel
	   */
	  onChange: _propTypes.default.func
	} : {};
	ExpansionPanel.defaultProps = {
	  defaultExpanded: false,
	  disabled: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanel'
	})(ExpansionPanel);
	
	exports.default = _default;

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	
	var _ExpansionPanel = _interopRequireDefault(__webpack_require__(432));

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 3, "px ").concat(theme.spacing.unit * 3, "px")
	    }
	  };
	};
	
	exports.styles = styles;
	
	function ExpansionPanelDetails(props) {
	  var classes = props.classes,
	      children = props.children,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), children);
	}
	
	ExpansionPanelDetails.propTypes =  false ? {
	  /**
	   * The content of the expansion panel details.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelDetails'
	})(ExpansionPanelDetails);
	
	exports.default = _default;

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	
	var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(871));

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(94));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(247));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    root: {
	      display: 'flex',
	      minHeight: theme.spacing.unit * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: "0 ".concat(theme.spacing.unit * 3, "px 0 ").concat(theme.spacing.unit * 3, "px"),
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      },
	      '&$expanded': {
	        minHeight: 64
	      },
	      '&$focused': {
	        backgroundColor: theme.palette.grey[300]
	      },
	      '&$disabled': {
	        opacity: 0.38
	      }
	    },
	    expanded: {},
	    focused: {},
	    disabled: {},
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '& > :last-child': {
	        paddingRight: theme.spacing.unit * 4
	      },
	      '&$expanded': {
	        margin: '20px 0'
	      }
	    },
	    expandIcon: {
	      position: 'absolute',
	      top: '50%',
	      right: theme.spacing.unit,
	      transform: 'translateY(-50%) rotate(0deg)',
	      transition: theme.transitions.create('transform', transition),
	      '&:hover': {
	        // Disable the hover effect for the IconButton,
	        // because a hover effect should apply to the entire Expand button and
	        // not only to the IconButton.
	        backgroundColor: 'transparent'
	      },
	      '&$expanded': {
	        transform: 'translateY(-50%) rotate(180deg)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ExpansionPanelSummary =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ExpansionPanelSummary, _React$Component);
	
	  function ExpansionPanelSummary() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, ExpansionPanelSummary);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ExpansionPanelSummary.__proto__ || (0, _getPrototypeOf.default)(ExpansionPanelSummary)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {
	        focused: false
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleFocus", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        _this.setState({
	          focused: true
	        });
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBlur", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        _this.setState({
	          focused: false
	        });
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleChange", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var _this$props = _this.props,
	            onChange = _this$props.onChange,
	            onClick = _this$props.onClick;
	
	        if (onChange) {
	          onChange(event);
	        }
	
	        if (onClick) {
	          onClick(event);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(ExpansionPanelSummary, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          disabled = _props.disabled,
	          expanded = _props.expanded,
	          expandIcon = _props.expandIcon,
	          onChange = _props.onChange,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "onChange"]);
	      var focused = this.state.focused;
	      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	        focusRipple: false,
	        disableRipple: true,
	        disabled: disabled,
	        component: "div",
	        "aria-expanded": expanded,
	        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.focused, focused), _classNames), className)
	      }, other, {
	        onFocusVisible: this.handleFocus,
	        onBlur: this.handleBlur,
	        onClick: this.handleChange
	      }), _react.default.createElement("div", {
	        className: (0, _classnames.default)(classes.content, (0, _defineProperty2.default)({}, classes.expanded, expanded))
	      }, children), expandIcon && _react.default.createElement(_IconButton.default, {
	        disabled: disabled,
	        className: (0, _classnames.default)(classes.expandIcon, (0, _defineProperty2.default)({}, classes.expanded, expanded)),
	        component: "div",
	        tabIndex: -1,
	        "aria-hidden": "true"
	      }, expandIcon));
	    }
	  }]);
	  return ExpansionPanelSummary;
	}(_react.default.Component);
	
	ExpansionPanelSummary.propTypes =  false ? {
	  /**
	   * The content of the expansion panel summary.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * If `true`, the summary will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * If `true`, expands the summary, otherwise collapse it.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func
	} : {};
	ExpansionPanelSummary.defaultProps = {
	  disabled: false
	};
	ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelSummary'
	})(ExpansionPanelSummary);
	
	exports.default = _default;

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	
	var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(434));

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _colorManipulator = __webpack_require__(55);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(94));
	
	var _helpers = __webpack_require__(35);
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      width: 48,
	      height: 48,
	      padding: 0,
	      borderRadius: '50%',
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	    colorInherit: {
	      color: 'inherit'
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    disabled: {},
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/style/icons) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	
	function IconButton(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
	    centerRipple: true,
	    focusRipple: true,
	    disabled: disabled
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	}
	
	IconButton.propTypes =  false ? {
	  /**
	   * The icon element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple will be disabled.
	   */
	  disableRipple: _propTypes.default.bool
	} : {};
	IconButton.defaultProps = {
	  color: 'default',
	  disabled: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(246));

/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdExpandMore = function MdExpandMore(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.7 14.3l2.3 2.3-10 10-10-10 2.3-2.3 7.7 7.7z' })
	        )
	    );
	};
	
	exports.default = MdExpandMore;
	module.exports = exports['default'];

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _ExpansionPanel = __webpack_require__(433);
	
	var _ExpansionPanel2 = _interopRequireDefault(_ExpansionPanel);
	
	var _ExpansionPanelDetails = __webpack_require__(872);
	
	var _ExpansionPanelDetails2 = _interopRequireDefault(_ExpansionPanelDetails);
	
	var _ExpansionPanelSummary = __webpack_require__(435);
	
	var _ExpansionPanelSummary2 = _interopRequireDefault(_ExpansionPanelSummary);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _expandMore = __webpack_require__(731);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _mentions;
	
	  return {
	    expansionPanel: {
	      boxShadow: 'none',
	      border: '1px solid ' + theme.palette.borders.cloudier
	    },
	    expansionPanelSummary: {
	      background: theme.palette.primary.main
	    },
	    expansionPanelSummaryHeading: {
	      flexBasis: '40%',
	      flexShrink: 0,
	      color: '#fff'
	    },
	    mentions: (_mentions = {
	      minHeight: 40,
	      padding: '2px 0',
	      display: 'flex',
	      alignItems: 'center',
	      color: theme.palette.primary.main
	    }, _mentions[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em'
	    }, _mentions),
	    mentionCounterOuter: {
	      display: 'inline-block',
	      borderRadius: '50%',
	      background: theme.palette.primary.main,
	      color: '#fff',
	      fontWeight: 500
	    },
	    mentionCounterInner: {
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: 35,
	      height: 35
	    }
	  };
	};
	
	var Mentions = function (_React$Component) {
	  _inherits(Mentions, _React$Component);
	
	  function Mentions() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Mentions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { expanded: false }, _this.componentDidMount = function () {
	      var mentions = _this.props.mentions;
	
	      if (Array.isArray(mentions)) {
	        if (mentions.length > 0) {
	          return _this.setState({ expanded: true });
	        }
	      }
	    }, _this.openPanel = function () {
	      return _this.setState({ expanded: !_this.state.expanded });
	    }, _this.renderMentions = function () {
	      var _this$props = _this.props,
	          classes = _this$props.classes,
	          mentions = _this$props.mentions;
	
	      if (!mentions) {
	        return _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.mentions },
	          'No mentions yet'
	        );
	      }
	      return mentions.map(function (mention, i) {
	        return _react2.default.createElement(
	          _Typography2.default,
	          {
	            component: 'div',
	            key: mention,
	            target: '_blank',
	            className: classes.mentions
	          },
	          _react2.default.createElement(
	            'div',
	            { className: classes.mentionCounterOuter },
	            _react2.default.createElement(
	              'div',
	              { className: classes.mentionCounterInner },
	              i + 1
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: mention, target: '_blank', style: { paddingLeft: 10 } },
	            mention
	          )
	        );
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Mentions.prototype.render = function render() {
	    var state = this.state;
	    var _props = this.props,
	        classes = _props.classes,
	        mentions = _props.mentions;
	
	
	    var timesMentioned = Array.isArray(mentions) ? mentions.length : 0;
	
	    return _react2.default.createElement(
	      _ExpansionPanel2.default,
	      {
	        classes: { root: classes.expansionPanel },
	        expanded: state.expanded,
	        onChange: this.openPanel
	      },
	      _react2.default.createElement(
	        _ExpansionPanelSummary2.default,
	        {
	          classes: { root: classes.expansionPanelSummary },
	          expandIcon: _react2.default.createElement(_expandMore2.default, { style: { color: '#ecf4f2' } })
	        },
	        _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.expansionPanelSummaryHeading },
	          'Mentioned',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { style: { fontWeight: 500, color: '#4fecfb' } },
	            timesMentioned
	          ),
	          ' ',
	          'times'
	        )
	      ),
	      _react2.default.createElement(
	        _ExpansionPanelDetails2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderMentions()
	        )
	      )
	    );
	  };
	
	  return Mentions;
	}(_react2.default.Component);
	
	Mentions.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  mentions: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	exports.default = (0, _withStyles2.default)(styles)(Mentions);
	module.exports = exports['default'];

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _gatsbyImage = __webpack_require__(382);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Phaser = __webpack_require__(132);
	
	var _Phaser2 = _interopRequireDefault(_Phaser);
	
	var _Meta = __webpack_require__(48);
	
	var _Mentions = __webpack_require__(929);
	
	var _Mentions2 = _interopRequireDefault(_Mentions);
	
	var _theme = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _extends2, _body;
	
	  return {
	    container: _extends({}, (0, _theme.pageStyle)(theme), (_extends2 = {
	      width: 700,
	      margin: 'auto'
	    }, _extends2[theme.breakpoints.down('sm')] = {
	      width: '100%'
	    }, _extends2)),
	    body: (_body = {}, _body[theme.breakpoints.down('xs')] = {
	      fontSize: '0.8em'
	    }, _body)
	  };
	};
	
	var WorkoutTemplate = function WorkoutTemplate(props) {
	  var classes = props.classes,
	      theme = props.theme,
	      data = props.data,
	      pathContext = props.pathContext;
	  var workout = data.markdownRemark,
	      sizes = data.imageSharp.sizes,
	      file = data.file;
	  var articleBody = pathContext.articleBody;
	
	
	  var datePublished = new Date(file.birthTime).toISOString();
	  var dateModified = file.modifiedTime;
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    {
	      id: 'workoutPage',
	      classes: { container: classes.container },
	      justify: 'center',
	      spacing: 24,
	      container: true
	    },
	    _react2.default.createElement(_Meta.ArticleMeta, {
	      title: workout.frontmatter.title,
	      shortDescription: workout.frontmatter.shortDescription,
	      thumbnail: workout.frontmatter.thumbnail,
	      genre: 'health-fitness',
	      tags: workout.frontmatter.tags,
	      wordCount: workout.wordCount.words,
	      datePublished: datePublished,
	      dateModified: dateModified,
	      articleBody: articleBody,
	      excerpt: workout.excerpt,
	      path: workout.fields.slug
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { xs: 12, classes: { item: classes.body }, item: true },
	      _react2.default.createElement(_Phaser2.default, { fontSize: '2.2em', label: workout.frontmatter.title }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        sizes: sizes,
	        title: workout.frontmatter.title,
	        alt: workout.frontmatter.title
	      }),
	      _react2.default.createElement('div', {
	        className: 'markdown',
	        dangerouslySetInnerHTML: { __html: workout.html }
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: { paddingTop: 20 } },
	        _react2.default.createElement(_Mentions2.default, { mentions: workout.frontmatter.mentions })
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            textAlign: 'center',
	            padding: 30
	          }
	        },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/weight-loss-workouts' },
	          _react2.default.createElement(
	            _Button2.default,
	            { variant: 'raised', size: 'small', color: 'primary' },
	            'Back to workouts'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n        div.markdown img {\n          width: 100%;\n          height: 350px;\n          object-fit: cover;\n        }\n        div.markdown {\n          color: ' + theme.palette.text.soft + ';\n        }\n        table {\n          border: 1px solid ' + theme.palette.primary.main + ';\n        }\n        table th {\n          background: ' + theme.palette.primary.main + ';\n          color: #fff;\n          padding: 10px;\n        }\n        table td {\n          border: 1px solid ' + theme.palette.borders.cloud + ';\n        }\n        h1, h2, h3, h4, h5, h6 {\n          line-height: 1em;\n        }\n        h1 {\n          padding: 20px 0;\n        }\n        @media (max-width: 600px) {\n          div.markdown h1, h2, h3 {\n            font-size: 1.4em;\n          }\n          div.markdown img {\n            height: 100%;\n          }\n        }\n      '
	    )
	  );
	}; //
	
	WorkoutTemplate.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object,
	  pathContext: _propTypes2.default.shape({
	    articleBody: _propTypes2.default.string.isRequired
	  })
	
	  // eslint-disable-next-line
	};var query = exports.query = '** extracted graphql fragment **';
	
	// prettier-ignore
	exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles, { withTheme: true }))(WorkoutTemplate);

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-workout-js-610d4b06d1c815c94e39.js